/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurveySummary = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        resident: {
    type: 'string',
    isRequired: true,
},
        room: {
    type: 'IdName',
    isRequired: true,
},
        data: {
    type: 'array',
    contains: {
        type: 'SatisfactionSurveyDataResponse',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};